import useAppSelector from '../../../../store/hooks/useAppSelector'
import { checkoutCapacityConflictActiveOptionSelector } from '../../store/checkoutSelectors'
import { CapacityConflictOptionType } from '../../types'

import CapacityConflictChoiceStep from './CapacityConflictChoiceStep'
import CapacityConflictSelectTimeStep from './CapacityConflictSelectTimeStep'
import CapacityConflictAdjustOrderStep from './CapacityConflictAdjustOrderStep'
import CapacityConflictDeleteOrderStep from './CapacityConflictDeleteOrderStep'

export default function CapacityConflictSomeBlocked() {
  const activeOption = useAppSelector(
    checkoutCapacityConflictActiveOptionSelector,
  )

  switch (activeOption) {
    case CapacityConflictOptionType.ChangePickupTime:
      return <CapacityConflictSelectTimeStep />

    case CapacityConflictOptionType.AdjustOrder:
      return <CapacityConflictAdjustOrderStep />

    case CapacityConflictOptionType.DeleteOrder:
      return <CapacityConflictDeleteOrderStep />

    default:
      return <CapacityConflictChoiceStep />
  }
}
